var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA1\x9C\xEA\xB3\xA0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xEB\x84\xA4\xEC\x9D\xB4\xEB\xB2\x84\xEB\xA1\x9C\xEA\xB3\xA0",
    d: "M12.8999 10.5L7.8499 3.25H3.6499V16.75H8.0499V9.55L13.0999 16.8H17.2999V3.3H12.8999V10.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNaver);
export default __webpack_public_path__ + "static/media/ic_naver.26a9e4afb7bb84479d5bc79c6446e786.svg";
export { ForwardRef as ReactComponent };